import React, {useState} from "react";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import codeDataStore from "../../../../common/codedata/store/CodeDataStore";
import CommonUtil from "../../../../utils/CommonUtil";
import StringUtil from "../../../../utils/StringUtil";
import UIUtils from "../../../../utils/UIUtils";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";
import UI from "../../../../components/UI";

function ContentsContainer() {
	const serverUrl = 'http://dev.fund.win-win.or.kr/';
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();
	
	const [handNoFMT, setHandNoFMT] = useState('');
	const [handAmt, setHandAmt] = useState('');
	const [handDate, setHandDate] = useState(new Date());
	const [donDate, setDonDate] = useState(new Date());
	const [notes, setNotes] = useState('');
	const [bizNm1, setBizNm1] = useState('');
	const [bizNm2, setBizNm2] = useState('');
	const [donAmt, setDonAmt] = useState('');
	const [remainDonAmt, setRemainDonAmt] = useState('');
	const [judgeOtherList, setJudgeOtherList] = React.useState<any[]>([]);
	const [judgeDList, setJudgeDList] = React.useState<any[]>([]);
	const [judgeIList, setJudgeIList] = React.useState<any[]>([]);
	const [judgeUList, setJudgeUList] = React.useState<any[]>([]);

	//밑에 담당자 정보
	const [corpNm,setCorpNm] = useState(''); //과제명
	const [bizNo,setBizNo] = useState(''); //사업자번호
	const [bizCd,setBizCd] = useState(''); //사업자번호
	const [oldBizCd, setOldBizCd] = useState('');
	const [corpRegNo,setCorpRegNo] = useState(''); //사업자번호
	const [personNm,setPersonNm] = useState(''); //이름
	const [posiNm,setPosiNm] = useState(''); //직급
	const [deptNm,setDeptNm] = useState(''); //부서명
	const [emailAdres,setEmailAdres] = useState(''); //이메일
	const [ofcTelNo,setOfcTelNo] = useState(''); //전화번호

	/** 검색조건 */
	const [donNo,setDonNo] = useState('');
	const [handNo,setHandNo] = useState('');
	const [REC, setREC] = useState<any>({});


	const [handStsNm,setHandStsNm] = useState('');

	//파일정보 선언
	const [reqFileNm, setReqFileNm] = useState('');

	const [corpLogoFileValue] = useState(new TbComFile());
	const [bizLicFileValue] = useState(new TbComFile());
	const [fileValue] = useState(new TbComFile());
	const [reqFileValue] = useState(new TbComFile());

	const [uploadComp, setUploadComp] = useState(false);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [fileInfoListPop, setFileInfoListPop] = React.useState<any[]>([]);


	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	async function initCall(){

		setDonNo(receivedData.vDON_NO);

		let param = {};
		param = {
			"HAND_NO": receivedData.vHAND_NO,
			"DON_NO": receivedData.vDON_NO
		};

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'usr_2011',
			data: param
		})
		const result = response
		console.log(result);

		setRemainDonAmt(result.REMAIN_DON_AMT)
		setREC(result.REC[0]);

		setHandNo(result.REC[0].HAND_NO);
		setHandNoFMT(result.REC[0].HAND_NO);
		setHandStsNm(result.REC[0].HAND_STS_NM);
		setHandAmt(result.REC[0].HAND_AMT);
		setDonAmt(result.REC[0].DON_AMT);
		setBizNm1(result.REC[0].BIZ_NM1)
		setBizNm2(result.REC[0].BIZ_NM2)
		setOldBizCd(result.REC[0].BIZ_CD) //전용 타겟 biz_cd ( before )
		setBizCd(result.REC[0].DTL_BIZ_CD)
		setDonNo(result.REC[0].DTL_DON_NO)
		setNotes(result.REC[0].NOTES)
		setHandDate(new Date(result.REC[0].HAND_DATE));
		setDonDate(new Date(Number(result.REC[0].DON_DATE2)));


		setJudgeDList(result.REC2.filter(x => x.HAND_STS_CD == 'D'));
		setJudgeOtherList(result.REC2.filter(x => 'A,B,H,G'.indexOf(x.HAND_STS_CD) != -1 ));

		// REQ - 신청서, PLAN - 계획서, 수행기관 사업자 등록증 - BIZ
		fileValue.setTbComFileMapngDetailList([]);
		reqFileValue.setTbComFileMapngDetailList([]);
		let fileList = result.FILE_INFO;
		for(let i = 0; i < fileList.length; i++){

			if(fileList[i].FILE_GB == 'REQ'){
				let reqFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(reqFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(reqFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(reqFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(reqFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(reqFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(reqFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(reqFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(reqFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(reqFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(reqFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(reqFileInfo.REGIST_DT);
				reqFileValue.putTbComFileMapngDetailList(fileDetail);
				//setReqFileNm(reqFileInfo.ORGINL_FILE_NM);

			}else{
				let fileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(fileInfo.DWLD_ID);
				fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
				fileDetail.setStrePath(fileInfo.STRE_PATH);
				fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
				fileDetail.setFileSize(fileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(fileInfo.REGIST_DT);
				fileValue.putTbComFileMapngDetailList(fileDetail);
			}


		}


		const response2:any = await CommonUtil.execute({
			url:'TbComPersonEntityMapper_select',
			data: param
		})


		const result2 = response2;
		console.log(result2)

		setCorpNm(result2.CORP_NM);
		setBizNo(result2.BIZ_NO);
		setCorpRegNo(result2.CORP_REG_NO);
		setPersonNm(result2.PERSON_NM);
		setPosiNm(result2.POSI_NM);
		setDeptNm(result2.DEPT_NM);
		setEmailAdres(result2.EMAIL_ADRES);
		setOfcTelNo(result2.OFC_TEL_NO);

		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}
	};

	// init
	React.useEffect(() => {
		initCall();
	},[])

	function updateAllo(){
		let vHAND_NO= handNo.replaceAll('-', '');
		let vDON_NO = donNo;

		let dataToSend = {vHAND_NO,vDON_NO};

		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './usr_2012',
			state: { data: dataToSend }
		});
	}


	async function deleteAllo(){
		if(await UIUtils.confirm('삭제 하시겠습니까?')){
			let vHAND_NO= handNo.replaceAll('-', '');
			let vDON_NO = donNo;

			let dataToSend = {vHAND_NO,vDON_NO};

			let param = {
				"DON_NO": donNo,
				"BIZ_NO": bizNo,
				"BIZ_CD": bizCd,
				"OLD_BIZ_CD": oldBizCd,
				"HAND_NO": handNo
			};

			const response:any = await CommonUtil.execute({
				url:'use_2011_delete',
				data: param
			})

			const result = response;

			UIUtils.alert('삭제 되었습니다.').then();
			// 다른 페이지로 이동하면서 데이터 전달
			history.push({
				pathname: './usr_2009',
				state: { data: {} }
			});
		}


	}


	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={1} lnbIdx={3}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">전용 요청 상세</h1>
					<section className="fund-section">
						<h3 className="section-title mb15">전용 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">처리 번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={handNoFMT} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전용상태</p>
									<div className="fo-value">
										{handStsNm == '신청' ? ( <label className="badge badge-22 blue">신청</label> ) : '' }
										{handStsNm == '접수중' ? ( <label className="badge badge-22 yellow">접수중</label> ) : '' }
										{handStsNm == '반려' ? ( <label className="badge badge-22 red">반려</label> ) : ''}
										{handStsNm == '승인완료' ? ( <label className="badge badge-22 gray">승인완료</label> ) : ''}
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전용금액(원)</p>
									<div className="fo-value">
										<div className="fund-form-group">
											<div className="fund-form-items tf-unit">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(handAmt)) || ""} placeholder={''}  readOnly={true}  />
												<span className="u">원</span>
											</div>
											<div className="tx-msg ml10"><span className="fc-pri">{StringUtil.isNotEmpty(Number(handAmt) + "")
											? '('+StringUtil.numKorPattern(Number(handAmt)) + " 원)"
											: ""}</span></div>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전용가능잔액</p>
									<div className="fo-value">
										<div className="fund-form-group">
											<div className="fund-form-items tf-unit">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(remainDonAmt)) || ""} placeholder={''}  readOnly={true}  />
												<span className="u">원</span>
											</div>
											<div className="tx-msg ml10"><span className="fc-pri">{StringUtil.isNotEmpty(Number(remainDonAmt) + "")
											? '('+StringUtil.numKorPattern(Number(remainDonAmt)) + " 원)"
											: ""}</span></div>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전용신청일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={dateToStr(handDate)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전용일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={dateToStr(donDate)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">비고사항</p>
									<div className="fo-value">
										<div className="ta-group w100p">
											{
												notes.split('\n').map((note, idx) => {
													return (
														<span key={idx}>{note}<br/></span>
													);
												})
											}
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<div className="pt">
							<div className="row">
								<div className="col col-5">
									<h3 className="section-title mb15">변경 전 출연 내용</h3>
									<form className="fo fo-col2" name="" action="" method="">
										<div className="inner">
											<div className="fo-item fo-m-1-3">
												<p className="fo-key">출연사업명</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={bizNm1} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item fo-m-1-3">
												<p className="fo-key">출연금액(원)</p>
												<div className="fo-value">
													<div className="fund-form-group">
														<div className="fund-form-items tf-unit">
															<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(donAmt)) || ""} placeholder={''}  readOnly={true}  />
															<span className="u">원</span>
														</div>
														<div className="tx-msg ml10"><span className="fc-pri">{StringUtil.isNotEmpty(Number(donAmt) + "")
														? '('+StringUtil.numKorPattern(Number(donAmt)) + " 원)"
														: ""}</span></div>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
								<div className="col col-5">
									<h3 className="section-title mb15">변경 후 전용 내용</h3>
									<form className="fo fo-col2" name="" action="" method="">
										<div className="inner">
											<div className="fo-item fo-m-1-3">
												<p className="fo-key">전용사업명</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={bizNm2} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item fo-m-1-3">
												<p className="fo-key">전용금액(원)</p>
												<div className="fo-value">
													<div className="fund-form-group">
														<div className="fund-form-items tf-unit">
															<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(handAmt)) || ""} placeholder={''}  readOnly={true}  />
															<span className="u">원</span>
														</div>
														<div className="tx-msg ml10"><span className="fc-pri">{StringUtil.isNotEmpty(Number(handAmt) + "")
											? '('+StringUtil.numKorPattern(Number(handAmt)) + " 원)"
											: ""}</span></div>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<h3 className="section-title hz-item">첨부파일</h3>
						</div>
						<form className="fo fo-col2 mb18" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">전용신청공문</p>
									<div className="fo-value">
										<UI.FileDownloadSimpleMode value={reqFileValue} viewMode={"simple2"}/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<div className="fo-value">
										<div className={"w100p"}>
											<UI.FileDownload value={fileValue}/>
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">반려사유</h3>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="90px" />
										<col />
										<col width="230px" />
									</colgroup>
									<thead>
										<tr>
											<th scope="col">순번</th>
											<th scope="col">반려사유</th>
											<th scope="col">재단담당자명</th>
										</tr>
									</thead>
									<tbody>
										{
											judgeDList.length != 0 ? judgeDList.map((judge, idx) => (
													<tr key={idx}>
														<td>{idx + 1}</td>
														<td>{
															judge.JUDGE_CMT.split('\n').map((cmt) => {
																return (
																	<span>
																{cmt}
																		<br/>
															  </span>
																);
															})
														}</td>
														<td>{judge.REG_USERNM}</td>
													</tr>
												)) :
												<tr>
													<td colSpan={3}>
														<div className="nd">
															<p className="tx tx-cp2 fc-666">내역이 없습니다.</p>
														</div>
													</td>
												</tr>
										}
									</tbody>
								</table>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title hz-item mb15">심사 의견</h3>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="100px" />
										<col width="200px" />
										<col width="" />
										<col width="100px" />
										<col width="200px" />
									</colgroup>
									<thead>
										<tr>
											<th>순번</th>
											<th>심사진행상태</th>
											<th>심사의견</th>
											<th>담당자명</th>
											<th>업무처리일자</th>
										</tr>
									</thead>
									<tbody>
										{
											judgeOtherList.length != 0 ? judgeOtherList.map((judge, idx) => (
													<tr key={idx}>
														<td>{idx + 1}</td>
														<td>{judge.HAND_STS_NM}</td>
														<td>{
															judge.JUDGE_CMT.split('\n').map((cmt) => {
																return (
																	<span>
																{cmt}
																		<br/>
															  </span>
																);
															})
														}</td>
														<td>{judge.REG_USERNM}</td>
														<td>{judge.JUDGE_DATE}</td>
													</tr>
												)) :
												<tr>
													<td colSpan={5}>
														<div className="nd">
															{/* <i className="ic"></i> */} {/* [M.20240522]삭제 */}
															<p className="tx tx-cp2 fc-666">내역이 없습니다.</p>
														</div>
													</td>
												</tr>
										}
									</tbody>
								</table>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">기업 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpRegNo} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.bizCrpFormat(bizNo)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">담당자</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={personNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">직위</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={posiNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={deptNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={emailAdres} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.telephoneFormat(ofcTelNo)} placeholder={''} readOnly={true} />
									</div>
								</div>
							</div>
						</form>
					</section>
					<div className="hz-root hz-right hz-gap10 mt30">
						{ handStsNm === '신청' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="pri-o2" size="md" onClick={() => updateAllo()}>수정</Button>
								<Button color="gray-o" size="md" onClick={() => deleteAllo()}>삭제</Button>
								<Button color="gray-o" size="md" onClick={() => window.history.back()}>목록</Button>
							</div>
						}
						{ handStsNm === '접수중' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="gray-o" size="md" onClick={() => deleteAllo()}>삭제</Button>
								<Button color="gray-o" size="md" onClick={() => window.history.back()}>목록</Button>
							</div>
						}
						{ handStsNm === '반려' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="gray-o" size="md" onClick={() => window.history.back()}>목록</Button>
							</div>
						}
						{ handStsNm === '승인완료' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="gray-o" size="md" onClick={() => window.history.back()}>목록</Button>
							</div>
						}
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;